import { Suspense } from 'react';
import Spinner from 'Spinner';
import Form from './Form';
import { post } from 'axios';
import React from "react";
import config from '../../../config';

function NewResource(props) {
  const resourceUrl = `${config.API_PATH}/resource`;

  const save = async (data) => {
    try {
      const response = await post(`${resourceUrl}`, data);
      props.history.replace({
        pathname: `/resource/${response.data.id}`,
        state: { created: true }
      });
    } catch (error) {
      return error;
    }
  };

  return (
    <>
      <Suspense fallback={<Spinner />}>
        <Form save={save} />
      </Suspense>
    </>
  );
}

export default NewResource;
